import React, { useEffect, useState } from 'react';
import './redirector.css';

const Redirector = () => {
  const [verificando, setVerificando] = useState(true);

  useEffect(() => {
    const verificarProgresso = async () => {
      try {
        const res = await fetch('http://localhost/nutrifacil/check-progresso.php', {
          credentials: 'include'
        });

        const data = await res.json();

        if (data.erro) {
          console.error('Erro do backend:', data.erro);
          window.location.href = '/';
          return;
        }

        if (typeof data.proxima_etapa !== 'undefined') {
          if (data.proxima_etapa === null) {
            window.location.href = '/painel';
          } else {
            window.location.href = '/quiz';
          }
        } else {
          console.error('Resposta inesperada:', data);
          window.location.href = '/';
        }

      } catch (error) {
        console.error('Erro na requisição:', error);
        window.location.href = '/';
      } finally {
        setVerificando(false);
      }
    };

    verificarProgresso();
  }, []);

  return (
    <div className="redirector-container">
      <div className="spinner"></div>
      <p>Verificando progresso...</p>
    </div>
  );
};

export default Redirector;
